import React from "react";

import { styled } from "@mui/material";
import { getFontWeightAndStyle } from "@src/formatters";
import { useQuantityButtonsContext } from "@src/QuantityButtonsView/context/QuantityButtonsContext";

import { useProgressBarContext } from "../../../../ProgressBarView/context/ProgressBarContext";

export const CartText = () => {
  const { state } = useProgressBarContext();
  const text =
    state.nextBreakpoint?.incompleteText ??
    state.completedBreakpoint?.completeText ??
    "";

  return (
    <Text
      className={"ig-cart-text"}
      dangerouslySetInnerHTML={{ __html: text || "&nbsp;" }}
    />
  );
};

const Text = styled("div")(() => {
  const { config } = useProgressBarContext();
  const { fontWeight, fontStyle } = getFontWeightAndStyle(
    config.desktop.widget.styles.typography.dynamicProgressText.fontStyle
  );
  const fontSize =
    config.desktop.widget.styles.typography.dynamicProgressText.fontSize;

  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    fontSize,
    fontWeight,
    fontStyle,
    color: config.desktop.widget.styles.textColors.dynamicProgressText,
    "& p": {
      margin: 0,
    },
    userSelect: "none",
  };
});
